import Task from "../task";
import {toMomentDate} from "../../../gd/convert/moment-date";
import {calculateDisplayDates} from "../functions/display-dates";
import {taskAutoUpdateScheduleDate} from "./auto-update-schedule";


export type UpdateDateOptions = {
    keepCalendarDuration?   : boolean
}


export default function taskUpdateStartDate(task:Task, startDate:Moment|null, options:UpdateDateOptions={}) {

    let endStartDiff : number|undefined = undefined

    if (options.keepCalendarDuration && task.startDate && task.endDate) {
        endStartDiff = moment(task.endDate).diff(moment(task.startDate), 'days')
    }

    task.startDate = toMomentDate(startDate)

    // if we set start date to null, end date should be null too
    if (startDate === null) {
        task.endDate = null
    }

    if (task.startDate && !task.endDate) {
        task.endDate = toMomentDate(task.startDate)
    }

    // if endDate BEFORE start set start = end because we update START here
    if (task.startDate && task.endDate && task.endDate.isBefore(task.startDate,'days')) {
        task.endDate = toMomentDate(task.startDate)
    }

    if (options.keepCalendarDuration && task.startDate && endStartDiff!==undefined) {
        task.endDate    = moment(task.startDate).add(endStartDiff,'days')
    }

    // schedule
    task.autoUpdateScheduleDate()



    // calculateDisplayDates(task)


    // console.log(task.toJSON())

}